import { render, staticRenderFns } from "./CmsList.vue?vue&type=template&id=50476cf4&scoped=true"
import script from "./CmsList.vue?vue&type=script&lang=js"
export * from "./CmsList.vue?vue&type=script&lang=js"
import style0 from "./CmsList.vue?vue&type=style&index=0&id=50476cf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50476cf4",
  null
  
)

export default component.exports